module.exports = __webpack_public_path__ + "img/23.8e9d6432.jpg";